/*
#############################################################################
# Copyright (c) 2022-2023 NVIDIA CORPORATION & AFFILIATES. All rights reserved.
#
# NVIDIA CORPORATION, its affiliates and licensors retain all intellectual
# property and proprietary rights in and to this material, related
# documentation and any modifications thereto. Any use, reproduction,
# disclosure or distribution of this material and related documentation
# without an express license agreement from NVIDIA CORPORATION or
# its affiliates is strictly prohibited.
###############################################################################
*/

/* eslint-disable no-console */
import React from "react";
import { useLocation } from "react-router-dom";
import { Box } from "@mui/material";
import InformationNode from "../features/item-custom/InformationNode";
import FeatureDiscoveryNode from "../features/item-custom/FeatureDiscovery";
import BlankNode from "../features/item-custom/BlankNode";


function CustomScreen() {
  const location = useLocation();

  let compType;
  let context;
  let isPortrait;
  let comp;
  
  try {
    compType = JSON.parse(sessionStorage.getItem(location.pathname))?.node || "";
    isPortrait = JSON.parse(sessionStorage.getItem(location.pathname))?.isPortrait;
    context = JSON.parse(sessionStorage.getItem(location.pathname))?.context;

    switch(compType.trim().toLowerCase())
    {
      case 'information':
        comp = <InformationNode context={context} isPortrait={isPortrait} />
        break;
      case 'feature_discovery':
        comp = <FeatureDiscoveryNode context={context} isPortrait={isPortrait} />
        break;
      default:
        comp = <BlankNode />
        break;
    }

  } catch (error) {
    console.error("Failed to parse custom component type", error);
  }
  console.log("custom component type", compType);


  const customScreenStyle = {
    overflow: "auto",
    display: "flex",
    maxHeight: "815px",
    minWidth: "100%",
    margin: 2,
    paddingLeft: 1,
    paddingRight: 4
  };

  return (
    <Box sx={ customScreenStyle } >
      {comp}
    </Box>
  );
}

export default CustomScreen;
